import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography } from '@coursera/cds-core';
import { SvgChevronRight } from '@coursera/coursera-ui/svg';

import CourseCertificate from 'bundles/accomplishments/components/course-certificates/CourseCertificate';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

import _t from 'i18n!nls/accomplishments';

import 'css!./__styles__/RecordTile';

type RecordTileProps = {
  userName: string;
  courseName: string;
  universityNames: string;
  certificateLink: string;
  completionDate: string;
  courseWorkload: string;
  courseNames?: [];
  instructorNames?: string;
  grade?: string;
  ownRecord?: boolean;
  recordLink: string;
};

const RecordTile = (props: RecordTileProps) => {
  const {
    courseNames,
    userName,
    courseName,
    universityNames,
    certificateLink,
    completionDate,
    courseWorkload,
    grade,
    instructorNames,
    ownRecord,
    recordLink,
  } = props;

  return (
    <div className="rc-RecordTile">
      <div className="record-certificate">
        <CourseCertificate
          userName={userName}
          courseName={courseName}
          universityNames={universityNames}
          certificateLink={recordLink}
        />
      </div>
      <div className="course-record-tile-details">
        <Typography className="course-name" variant="h2semibold" component="h3">
          {courseName}
        </Typography>
        <div className="course-details">
          <p>{universityNames}</p>
          {instructorNames && (
            <FormattedMessage
              message={_t(`Taught by: {instructorNames}`)}
              instructorNames={instructorNames}
              tagName="p"
            />
          )}
          <p>{completionDate}</p>
          <p>{courseWorkload}</p>
          {grade && ownRecord && (
            <FormattedMessage message={_t(`Grade Achieved: {grade}%`)} grade={grade} tagName="p" />
          )}
          {courseNames && (
            <p className="course-names">
              <p className="body-2-text">{_t('Course Certificates Completed')}</p>
              {courseNames.map((name) => (
                <p key={name}>{name}</p>
              ))}
            </p>
          )}
        </div>
        <TrackedA
          href={certificateLink}
          data-e2e="view-certificate"
          className="view-certificate"
          trackingName="view_certificate_link"
        >
          {_t('View this certificate')}
          <SvgChevronRight
            size={12}
            color="var(--cds-color-blue-600)"
            hoverColor="var(--cds-color-blue-700)"
            style={{
              marginLeft: '3px',
            }}
            aria-hidden
          />
        </TrackedA>
      </div>
    </div>
  );
};

export default RecordTile;
